import React, { useMemo } from 'react';
import cls from 'clsx';
import { Notification } from '@link/share/components';
import {
  getNotificationFullContent,
  getNotificationPreview
} from '@link/share/utils';
import { NotificationListProps } from './NotificationList.types';
import styles from './notification-list.module.css';

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  loading = false,
  className = '',
  itemClassName = ''
}) => {
  // Entries without a description don't get a card.
  const items = useMemo(
    () =>
      (notifications ?? [])
        .map(notification => ({
          id: notification.id,
          preview: getNotificationPreview(notification),
          dialogContent: getNotificationFullContent(notification)
        }))
        .filter(item => !!item.preview),
    [notifications]
  );

  if (loading) {
    return (
      <div className={cls(styles.list, className)}>
        <Notification loading className={itemClassName} />
      </div>
    );
  }

  if (!items.length) {
    return null;
  }

  return (
    <div className={cls(styles.list, className)}>
      {items.map((item, index) => (
        <Notification
          key={item.id || index}
          content={item.preview}
          dialogContent={item.dialogContent}
          className={itemClassName}
        />
      ))}
    </div>
  );
};

export default NotificationList;
